// Vendored shadcn primitives
export * from './components/accordion'
export * from './components/aspect-ratio'
export * from './components/badge'
export * from './components/button'
export * from './components/carousel'
export * from './components/checkbox'
export * from './components/field'
export * from './components/input'
export * from './components/input-otp'
export * from './components/label'
export * from './components/separator'
export * from './components/sheet'
export * from './components/slider'
export * from './components/table'
export * from './components/toggle'
export * from './components/toggle-group'
export * from './components/tooltip'
export * from './components/animate-presence'

// Marketing compositions (presentational — custom landing pages)
export * from './components/marketing'

// Icons
export * from './icons'

// Utilities
export { cn } from './lib/utils'
export { cva, type VariantProps } from 'class-variance-authority'
